import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import { Shimmer } from '@onefootprint/ui';
import type { JSX } from 'react';
import { useEntitiesContext } from '../../list/hooks/use-entities-context';
type MobileListProps = {
  'aria-label': string;
  emptyStateText: string;
  renderRow: (entity: Entity) => JSX.Element;
};
const MobileList = t0 => {
  const $ = _c(13);
  const {
    "aria-label": ariaLabel,
    emptyStateText,
    renderRow
  } = t0;
  const {
    data,
    isPending,
    onRowClick
  } = useEntitiesContext();
  if (isPending) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div aria-busy={true} className="flex flex-col gap-3 p-3 rounded-default border border-tertiary">{[0, 1, 2].map(_temp)}</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!data?.length) {
    let t1;
    if ($[1] !== emptyStateText) {
      t1 = <p className="px-3 py-3 text-body-2 text-primary rounded-default border border-tertiary">{emptyStateText}</p>;
      $[1] = emptyStateText;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== data || $[4] !== onRowClick || $[5] !== renderRow) {
    let t2;
    if ($[7] !== onRowClick || $[8] !== renderRow) {
      t2 = entity => <li key={entity.id} className="border-b border-tertiary last:border-b-0"><button type="button" onClick={event => onRowClick(entity, event)} className="flex flex-col gap-1 w-full min-h-11 px-3 py-2.5 text-left active:bg-secondary">{renderRow(entity)}</button></li>;
      $[7] = onRowClick;
      $[8] = renderRow;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = data.map(t2);
    $[3] = data;
    $[4] = onRowClick;
    $[5] = renderRow;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[10] !== ariaLabel || $[11] !== t1) {
    t2 = <ul aria-label={ariaLabel} className="overflow-hidden rounded-default border border-tertiary">{t1}</ul>;
    $[10] = ariaLabel;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
export default MobileList;
function _temp(i) {
  return <Shimmer key={i} aria-hidden={true} height="64px" width="100%" />;
}